import { twMerge } from "tailwind-merge";
import { printHTML } from "hooks/utils/formatter";
import ArrowButton from "components/General/ButtonGsfurn/ArrowButton";

const Entrances = ({ attrs }) => {
  const mainText = attrs?.data?.inhoud_tekst;
  const entrances = attrs?.data?.ingangen.filter(entrance => entrance?.afbeelding?.url); // Check if entrance has an image URL

  return (
    <section className="px-4 mx-auto mb-16 md:mb-20 xl:px-0 max-w-app">
      <div className="flex flex-col w-full gap-3 lg:flex-row lg:gap-6">

        <div className="w-full lg:w-1/2 rounded-md lg:rounded-10 p-8 lg:p-[6.5rem] bg-white">
          {mainText ? printHTML(mainText) : ""}
        </div>

        {(entrances && entrances?.length > 0) && 
          <div className="flex flex-wrap gap-3 overflow-hidden rounded-md lg:w-1/2 lg:gap-2">
            {entrances?.map((entrance, i) => {
              return (
                <a 
                  key={i} 
                  href={entrance?.link?.url || ""} 
                  title={entrance?.link?.title} 
                  target={entrance?.link?.target} 
                  className={twMerge(
                    "relative flex flex-grow flex-col w-full lg:w-[calc(50%-1.5rem*0.5)] group group/arrow min-h-40 max-h-[38rem]",
                    !entrance?.link?.url && "cursor-auto" 
                  )} 

                >
                  <img 
                    src={entrance?.afbeelding?.url} 
                    alt={entrance?.afbeeling?.alt} 
                    className="absolute object-cover w-full h-full rounded-md lg:rounded-none" 
                  />
                  {entrance?.link?.url && 
                    <div className="absolute w-full h-full transition-all duration-300 bg-black rounded-md opacity-0 lg:rounded-none group-hover:opacity-80"/>
                  }
                  <div className="absolute flex items-center justify-between bottom-5 inset-x-6">
                    <div className="font-bold text-white">{entrance?.titel}</div>
                    {entrance?.link?.url && 
                      <ArrowButton className="transition-all duration-300 opacity-0 group-hover:opacity-100"/>
                    }
                  </div>
                </a>
              )
            })}
          </div>
        }
        
      </div>
    </section>
  );
};

export default Entrances;